import React from 'react'
import { Container } from 'react-bootstrap'
import './direitos.css'

const Direitos = () => {
    return (

        <Container fluid className="ContainerDireitos">
            <div className="Direitos">
                <br/>  2022 © Todos os direitos reservados à Universidade Metodista de Angola
            </div>
        </Container>
    )
}

export default Direitos;